module.exports = __webpack_public_path__ + "static/media/logoWhite.703384c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logoWhite.svg
// module id = 1792
// module chunks = 0